import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import omit from 'lodash/fp/omit';
export var ActionBarItemPopoverContent = function ActionBarItemPopoverContent(_ref) {
  var className = _ref.className,
    children = _ref.children,
    remainingProps = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames('ActionBarItemPopoverContent', className);
  var filterProps = omit(['title', 'useOffscreen']);
  return /*#__PURE__*/React.createElement("div", _extends({}, filterProps(remainingProps), {
    className: classes
  }), children);
};
ActionBarItemPopoverContent.displayName = 'ActionBarItemPopoverContent';
ActionBarItemPopoverContent.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  useOffscreen: PropTypes.bool
};
export default ActionBarItemPopoverContent;